export function hasMeaningfulLabResult(row) {
  if (!row || typeof row !== 'object') return false;
  const textFields = ['value', 'synthesis'];
  if (textFields.some((field) => String(row[field] || '').trim())) return true;
  return Array.isArray(row.markers) && row.markers.some((marker) => (
    marker && ['value', 'synthesis'].some((field) => String(marker[field] || '').trim())
  ));
}

function hasPreservableLabResult(row) {
  if (hasMeaningfulLabResult(row)) return true;
  if (!row || typeof row !== 'object') return false;
  if (String(row.status || '').trim() || String(row.category || '').trim()) return true;
  return Array.isArray(row.markers) && row.markers.some((marker) => String(marker?.status || '').trim());
}

export function preservePreviousPlanResults(nextRows, previousRows) {
  const current = Array.isArray(nextRows) ? nextRows : [];
  const previous = Array.isArray(previousRows) ? previousRows : [];
  const currentKeys = new Set(current.map((row) => row?.test_code || row?.test_name).filter(Boolean));
  const preserved = previous.filter((row) => {
    const key = row?.test_code || row?.test_name;
    return key && !currentKeys.has(key) && hasPreservableLabResult(row);
  });
  return [...current, ...preserved];
}

export function canValidateResultsReview({ planLoadState, hasReviewedLabReport, results }) {
  if (planLoadState !== 'ready') return false;
  return hasReviewedLabReport === true || (Array.isArray(results) && results.some(hasMeaningfulLabResult));
}
